import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';
import { visibleColumns, sort } from './runupReduxConstants';


export const TSU_REL_RUNUP_DATA_TSUNAMI_REQUEST = 'TSU_REL_RUNUP_DATA_TSUNAMI_REQUEST';
export const TSU_REL_RUNUP_DATA_TSUNAMI_SUCCESS = 'TSU_REL_RUNUP_DATA_TSUNAMI_SUCCESS';
export const TSU_REL_RUNUP_DATA_TSUNAMI_FAILURE = 'TSU_REL_RUNUP_DATA_TSUNAMI_FAILURE';

export const TSU_REL_RUNUP_DATA_RUNUP_REQUEST = 'TSU_REL_RUNUP_DATA_RUNUP_REQUEST';
export const TSU_REL_RUNUP_DATA_RUNUP_SUCCESS = 'TSU_REL_RUNUP_DATA_RUNUP_SUCCESS';
export const TSU_REL_RUNUP_DATA_RUNUP_FAILURE = 'TSU_REL_RUNUP_DATA_RUNUP_FAILURE';


export const TSU_REL_RUNUP_DATA_DELETE_RUNUP_REQUEST = 'TSU_REL_RUNUP_DATA_DELETE_RUNUP_REQUEST';
export const TSU_REL_RUNUP_DATA_DELETE_RUNUP_SUCCESS = 'TSU_REL_RUNUP_DATA_DELETE_RUNUP_SUCCESS';
export const TSU_REL_RUNUP_DATA_DELETE_RUNUP_FAILURE = 'TSU_REL_RUNUP_DATA_DELETE_RUNUP_FAILURE';

export const TSU_REL_RUNUP_DATA_CLEAR = 'TSU_REL_RUNUP_DATA_CLEAR';
export const TSU_REL_RUNUP_DATA_SORT = 'TSU_REL_RUNUP_DATA_SORT';


export const TSU_REL_RUNUP_DATA_TOGGLE_COLUMN = 'TSU_REL_RUNUP_DATA_TOGGLE_COLUMN';

const excludedColumns = fromJS([
  'year',
  'month',
  'day',
  'hour',
  'minute',
  'second',
  'sourceEventValidity',
  'sourceCauseCode',
  'tsunamiEventId',
  'sourceEqMagnitude',
  'volcanoEventId',
]);

const initialState = fromJS({

  fetchedTsunami: false,
  tsunami: {},

  fetchedRunups: false,
  runups: [],
  sort,


  deleting: false,
  visibleColumns: visibleColumns.filter(value => !excludedColumns.contains(value)),

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const tsunamiRelatedRunupsDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case TSU_REL_RUNUP_DATA_CLEAR:
      return initialState.merge(fromJS({
        visibleColumns: state.get('visibleColumns'),
        sort: state.get('sort'),
      }));

    case TSU_REL_RUNUP_DATA_SORT:
      return state.merge(fromJS({
        runups: basicSort(action.sort, state.get('runups')),
        sort: action.sort,
      }));

    case TSU_REL_RUNUP_DATA_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    case TSU_REL_RUNUP_DATA_TSUNAMI_REQUEST:
      return state.merge(fromJS({
        fetchedTsunami: false,
      }));
    case TSU_REL_RUNUP_DATA_TSUNAMI_SUCCESS:
      return state.merge(fromJS({
        fetchedTsunami: true,
        tsunami: action.response,
      }));
    case TSU_REL_RUNUP_DATA_TSUNAMI_FAILURE:
      return state.merge(fromJS({
        fetchedTsunami: true,
      }));


    case TSU_REL_RUNUP_DATA_RUNUP_REQUEST:
      return state.merge(fromJS({
        fetchedRunups: false,
      }));
    case TSU_REL_RUNUP_DATA_RUNUP_SUCCESS:
      return state.merge(fromJS({
        fetchedRunups: true,
        runups: basicSort(state.get('sort'), fromJS(action.response.items)),
      }));
    case TSU_REL_RUNUP_DATA_RUNUP_FAILURE:
      return state.merge(fromJS({
        fetchedRunups: true,
      }));

    case TSU_REL_RUNUP_DATA_DELETE_RUNUP_REQUEST:
      return state.set('deleting', true);
    case TSU_REL_RUNUP_DATA_DELETE_RUNUP_SUCCESS:
    case TSU_REL_RUNUP_DATA_DELETE_RUNUP_FAILURE:
      return state.set('deleting', false);

    default:
      return state;
  }
};
